import urlJoin from "url-join";

export const getPathnameWithoutLocale = (pathname: string, currentLocale: string) => {
  const [locale, ...restSegments] = pathname.split("/").filter(Boolean);
  return locale === currentLocale ? urlJoin("/", ...restSegments) : pathname;
};
